<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="消息标题" @keydown.enter="resetSearch" clearable>
            <template #prefix>关键字</template>
          </el-input>
          <el-select v-model="searchInfo.category" placeholder="请选择预警消息类型" @change="resetSearch" clearable>
            <template #prefix>预警类型</template>
            <el-option v-for="item in messageType" :key="item.code" :value="item.code" :label="item.name"/>
          </el-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border>
          <yq-table-column label="预警信息" prop="messageTitle" min-width="180rem"/>
          <yq-table-column label="预警类型" prop="messageType" min-width="120rem">
            <template v-slot="{row}">
              <span v-for="item in messageType" :key="item.code">
                <span v-if="row.messageType === item.code">{{item.name}}</span>
              </span>
            </template>
          </yq-table-column>
          <yq-table-column label="预警消息" prop="summary" :show-overflow-tooltip="true"/>
          <yq-table-column label="预警时间" prop="publishTime"/>
          <yq-table-column  label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button @click="router.push(`/sys/message/view?id=${row.id}`)">查看</table-button>
                <table-button has-perm="sys:message:delete"  el-type="danger" message="是否确认删除数据,删除后系统中的其它数据也可能会被删除" @click="deleteData(row)">删除</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition";
import FormPage from "@/components/h5/layout/FormPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage";
import TableButton from "@/components/h5/button/TableButton";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import systemMessageApi from "@/api/normal/sys/systemMessageApi";
import commonApi from "@/api/commonApi";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      messageType: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
      // 预警消息类型， 开通了哪些服务
      commonApi.queryMerchantService().then(res => {
        let arr = [];
        for (let i = 0; i < res.length; i++) {
          if (res[i].serviceId === "10002") { // 路桥服务
            let s = [
              {code: "LUQIAO_ATTENDANCE_WARN", name: "考勤报警"},
              {code: "LUQIAO_TASK_WARN", name: "工作计划报警"},
              {code: "LUQIAO_HELMET", name: "安全帽预警"},
              {code: "LUQIAO_STRANGER", name: "陌生人预警"},
              {code: "LUQIAO_BLACK_LIST", name: "黑名单预警"},
              {code: "STOCK_LIMIT_WARN", name: "库存预警"},
            ];
            arr.push(...s);
          } else if (res[i].serviceId === "10005") { // ai商务
            arr.push({code: "AI_LOGOUT_WARN", name: "AI员工登出报警"})
          }
        }
        this.messageType = arr;
      });
      this.resetSearch();
    }
  },
  methods: {
    queryList() {
      systemMessageApi.queryWarnList(this.searchInfo).then(res => {
        this.dataList = res.records;
        this.searchInfo.totalCount = res.totalCount;
      });
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    // 撤回通知
    revoke(data) {
      systemMessageApi.revoke(data.id).then(() => {
        this.resetSearch();
      });
    },
    deleteData(data) {
      systemMessageApi.deleteWarn(data.id).then(() => {
        this.resetSearch();
      })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>